/* eslint-disable import/prefer-default-export */
const getGlobalState = (state, key) => (Array.isArray(state.goldenGoalSettings[key]) ? state.goldenGoalSettings[key].slice(0) : state.goldenGoalSettings[key]);

export const goldenGoalSettingsSelector = (state) => getGlobalState(state, 'goldenGoalSettingsConfigurations');
